import { getAmplitudeInstance } from '../amplitudeHelpers';
import TrailDetailsAction from '../enums/TrailDetailsAction';
import TrailPageType from '../enums/TrailPageType';

type logTrailDetailsWebtoAppModuleClickedParams = {
  trail_id?: string;
  trail_page_type?: TrailPageType;
  was_plus_when_web_to_app_started?: boolean;
  web_to_app_action?: TrailDetailsAction;
};

/**
 * User clicks a button or link on the web trail page that initiates a transfer to the app. This could be opening live share, opening a trail in the app, or downloading a trail in the app. Note: to determine had_app_when_web_to_app_started, use WebToAppPhonePopUpViewed.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - Trail page user was on when they clicked the web to app module.
 * @param params.trail_page_type - Type of trail page where the CTA was clicked
 * @param params.was_plus_when_web_to_app_started - TRUE if the user was a plus user when they started the web to app transfer.
 * @param params.web_to_app_action - The action that the user wants to transfer to their app.
 */
const logTrailDetailsWebtoAppModuleClicked = (
  { trail_id, trail_page_type, was_plus_when_web_to_app_started, web_to_app_action }: logTrailDetailsWebtoAppModuleClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details webto app module clicked',
    {
      'trail id': trail_id,
      'trail page type': trail_page_type,
      'was plus when web to app started': was_plus_when_web_to_app_started,
      'web to app action': web_to_app_action
    },
    callback
  );
};

export default logTrailDetailsWebtoAppModuleClicked;
